module.exports = file => () => import('@/modules/' + file + '.vue')



// WEBPACK FOOTER //
// ./src/utils/import/_import_production.js